import React from "react";
import styled from "styled-components";
import { useCallRequestCount } from "../hooks/useCallRequestCount";

const BadgeContainer = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const Badge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ef4444;
  color: white;
  border-radius: 50%;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  padding: 0 4px;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const CallRequestBadge = ({ children }) => {
  const { count, loading } = useCallRequestCount();

  if (loading || count === 0) {
    return <BadgeContainer>{children}</BadgeContainer>;
  }

  return (
    <BadgeContainer>
      {children}
      <Badge>{count > 99 ? "99+" : count}</Badge>
    </BadgeContainer>
  );
};

export default CallRequestBadge;
